import React, { useCallback, useEffect, useRef, useState } from "react";
import { getApiDashBoardData } from "../../api/api";
import Cookies from "js-cookie";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useGetDashboardData } from "../../data/data";
import { formateDataPrec } from "../../utils/types";
import _ from "lodash";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";
import { boolean } from "yup";
export interface IOlympicData {
  symbol: string;
  date: any;
  status: string;
  order: string;
  qty: string;
  price: number;
}
interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}

const PortfolioPerformance = () => {
  //const [data, setData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [filteredDeta, setFilteredDeta] = useState<any>(null);
  const selectedClient: any = Cookies.get("client");
  const dataGridRefMain = useRef<AgGridReact<IOlympicData>>(null);
  const { data, isFetching, refetch } = useGetDashboardData(
    "ParticipantPerformanceDetails",
    parseInt(selectedClient),
    Cookies.get("newJwt")
  );

  const filterByEndDate = _.uniqBy(data, "perfDate");

  function handleSelectedDate(e: any) {
    setSelectedDate(e.target.value);
  }

  const filteredData = _.filter(data, (item) => {
    if (!selectedDate) {
      return true;
    }
    return item.perfDate === selectedDate;
  });

  const rowData = filteredData ? [filteredData] : [];

  

  const [columns, setColumns] = useState([
    {
      headerName: "Name",
      field: "participantName",
      flex: 1,
      //width: 190,
    },
    {
      headerName: "MTD",
      field: "mtdNet",
      sortable: true,
      width: 90,
      cellRenderer: formateDataPrec,
    },
    {
      headerName: "3M",
      field: "threeMonthsNet",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 90,
    },
    {
      headerName: "6M",
      field: "qtdNet",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 90,
    },
    {
      headerName: "1Y",
      field: "oneYearNet",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 90,
    },
    {
      headerName: "3Y",
      field: "threeYearNet",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 90,
    },
    {
      headerName: "5Y",
      field: "fiveYearNet",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 90,
    },
    {
      headerName: "7Y",
      field: "sevenYearNet",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 90,
    },
    {
      headerName: "10Y",
      field: "tenYearNet",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 90,
    },
    {
      headerName: "ITD",
      field: "sinceInceptionNet",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 90,
    },
  ]);

  const handleExportExcel = useCallback(() => {
    const params = {
      processCellCallback: (params: any) => {
        if (params.column.colId === "dateColumn") {
          // Format date as desired
          return params.value
            ? new Date(params.value).toLocaleDateString()
            : "";
        }
        if (typeof params.value === "string") {
          // Apply currency symbol to string values
          return `${params.value}`;
        }
        if (typeof params.value === "number") {
          // Format numbers as currency with the currency symbol
          return `$${params.value.toFixed(2)}`;
        }
        if (params.column.colId.includes("Locked")) {
          // Render true/false as text
          return params.value; // or return "" + params.value;
        }

        if (params.column.colId.includes("Status")) {
          // Render true/false as text
          return params.value; // or return "" + params.value;
        }

        if (typeof params.value === "undefined") {
          // Format numbers as currency with the currency symbol
          return `--`;
        }
        return params.value !== null ? `$${params.value}` : "--";
      },
    };

    dataGridRefMain.current?.api.exportDataAsExcel(params);
  }, []);

  const handleExportPdf = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(8);

    const title = "Portfolio Performance";
    const headers = [
      ["Name", "MTD", "3M", "6M", "1Y", "3Y", "5Y", "7Y", "10Y", "ITD"],
    ];

    const transactionData = filteredData.map((e: any) => [
      e.participantName !== null ? `${e.participantName}` : "--",
      e.mtdNet !== null ? `${e.mtdNet}` : "--",
      e.qtdNet !== null ? `${e.qtdNet}` : "--",
      e.oneYearNet !== null ? `${e.oneYearNet}` : "--",
      e.threeYearNet !== null ? `${e.threeYearNet}` : "--",
      e.fiveYearNet !== null ? `${e.fiveYearNet}` : "--",
      e.sevenYearNet !== null ? `${e.sevenYearNet}` : "--",
      e.tenYearNet !== null ? `${e.tenYearNet}` : "--",
      e.sinceInceptionNet !== null ? `${e.sinceInceptionNet}` : "--",
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: transactionData,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("PortfolioPerformance.pdf");
  };

  return (
    <>
      {" "}
      <div className="col-12 d-flex justify-content-between align-items-baseline">
        <h5 className="mx-2">Portfolio Performance</h5>

        <div className="col-sm-6 d-flex justify-content-end align-items-baseline">
          <label className="text-small">Filter by end date</label>
          <select
            className="form-control text-small m-3 w-auto"
            onChange={handleSelectedDate}
          >
            <option value=''>select an end date</option>
            {filterByEndDate?.map((value: any, index: number) => {
              const date = new Date(value.perfDate);
              const formattedDate = date.toLocaleDateString();
              return (
                <option key={index} value={value.perfDate}>
                  {formattedDate}
                </option>
              );
            })}
          </select>
          <i
            className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
            style={{ fontSize: "16px" }}
            onClick={handleExportExcel}
          ></i>
          <i
            className="align-middle far fa-fw fa-file-pdf cursor-pointer"
            onClick={() => handleExportPdf()}
            style={{ fontSize: "16px" }}
          ></i>
        </div>
      </div>
      <div
        className="ag-theme-alpine"
        style={{
          height: "500px",
          width: "100%",
        }}
      >
        {isFetching ? (
          <div className="w-100 grid_loader">
            <div className="spinner-border text-dark me-2" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <AgGridReact
            ref={dataGridRefMain}
            rowData={filteredData}
            columnDefs={columns}
            animateRows={true}
            domLayout={"normal"}
            pagination={true}
            paginationPageSize={20}
            className="px-2"
            //paginationAutoPageSize={true}
          ></AgGridReact>
        )}
      </div>
    </>
  );
};

export { PortfolioPerformance };
